import gql from 'graphql-tag';

export const ADD_USER_TO_TENANT = gql`
  mutation AddUserToTenant($input: UserTenantAddInput!) {
    addUserToTenant(input: $input)
  }
`;
